<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('boxinspection.thirdStepInfo') }}
    </p>
    <hr />
    <div class="px-3">
      <div class="row sticky-button px-2">
        <div class="col-12 col-sm-7 col-md-5 col-lg-5 px-0">
          <div class="form-group has-label">
            <minus-plus
              :label="`${$t('production.defects_number')}: `"
              @handlePlus="handlePlus"
              @handleMinus="handleMinus"
              :value="model.defect_quantity"
              :showZero="true"
            />
          </div>
        </div>
      </div>
      <div
        v-for="(_, index) in model.defect_quantity"
        v-if="model.defect_quantity > 0"
        :key="index"
        class="px-3"
      >
        <div class="row">
          <div
            class="row py-3 mb-4 shadow-sm col-11"
            style="border: 0.5px solid #6ba6524d"
          >
            <select-component
              :dataOptions="boxes"
              :indexSelect="index"
              :initialSelection="model.defect_box[index]"
              :isMultiple="false"
              :labelSelect="`${$t('production.box')}: `"
              :requireClass="`required-defect_box`"
              :rowClass="`col-12 col-md-6 col-lg-3`"
              @onChange="handleChangeSelected"
              modelName="defect_box"
            />
            <select-component
              :dataOptions="defects"
              :indexSelect="index"
              :initialSelection="model.defect_id[index]"
              :isMultiple="false"
              :labelSelect="`${$t('production.defect')} ${index + 1}: `"
              :requireClass="`required-defect_id`"
              :rowClass="`col-12 col-md-6 col-lg-6`"
              @onChange="handleChangeSelected"
              modelName="defect_id"
            />
            <div class="col-12 col-sm-4 col-lg-3">
              <fg-input
                :label="`${$t('boxinspection.cluster_quantity')}: *`"
                class="input-defect_cluster_quantity"
                ref="defect_cluster_quantity"
                type="number"
                v-model="model.defect_cluster_quantity[index]"
                :name="`boxinspection.cluster_quantity_${index}`"
                v-validate="modelValidations.defect_cluster_quantity"
                :error="
                  getFieldErrorByIndex(
                    'boxinspection.cluster_quantity',
                    true,
                    index
                  )
                "
              ></fg-input>
            </div>
          </div>
          <div
            class="col-2 col-sm-4 col-lg-1 d-flex justify-content-center align-items-center"
          >
            <button
              class="btn btn-info custom-shadow-btn"
              @click="handleMinus(index)"
            >
              <em class="fa fa-minus"></em>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset, capitalizeString } from 'src/util/Util';
import { MixinExport } from 'src/mixins/mixin-export';
import i18n from 'src/i18n';
import MinusPlus from 'src/components/Forms/MinusPlus.vue';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinLoading from 'src/mixins/mixin-loading.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [MinusPlus.name]: MinusPlus,
  },
  data() {
    return {
      model: {
        defect_box: [],
        defect_id: [],
        defect_name_selected: [],
        defect_cluster_quantity: [],
        defect_quantity: 0,
      },
      modelValidations: {
        defect_cluster_quantity: {
          required: true,
          min_value: 1,
          max_value: 250,
        },
      },
      defects: [],
      boxes: [],
      availableBoxes: [
        { id: 1, name: '1' },
        { id: 2, name: '2' },
        { id: 3, name: '3' },
        { id: 4, name: '4' },
        { id: 5, name: '5' },
        { id: 6, name: '6' },
        { id: 7, name: '7' },
        { id: 8, name: '8' },
        { id: 9, name: '9' },
        { id: 10, name: '10' },
      ],
    };
  },
  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinExport,
    MixinForm,
    MixinValidations,
    mixinLoading,
  ],
  props: {
    box_quantity: {
      type: Number,
      default: 1,
    },
    box_total_clusters: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    box_quantity: {
      handler(newVal) {
        if (newVal && newVal !== this.boxes.length) {
          this.boxes = this.availableBoxes.slice(0, newVal);
          this.handleNumberChange();
        }
      },
      immediate: true,
    },
  },
  methods: {
    handlePlus() {
      this.model.defect_quantity++;
      const index = this.model.defect_quantity;
      this.model.defect_box[index - 1] = null;
      this.model.defect_id[index - 1] = null;
      this.model.defect_cluster_quantity[index - 1] = null;
    },
    handleMinus(index = null) {
      if (this.model.defect_quantity > 0) {
        if (index !== null) {
          // Eliminar el registro específico
          this.model.defect_box.splice(index, 1);
          this.model.defect_id.splice(index, 1);
          this.model.defect_cluster_quantity.splice(index, 1);

          this.model.defect_quantity--;
        } else {
          // Eliminar el último
          this.model.defect_quantity--;
          this.handleNumberChange();
        }
      }
    },
    handleNumberChange() {
      const fields = ['defect_box', 'defect_id', 'defect_cluster_quantity'];

      fields.forEach((field) => {
        const values = [...(this.model[field] || [])];
        this.$set(
          this.model,
          field,
          values.slice(0, this.model.defect_quantity)
        );
      });
    },

    handleChangeSelected(data) {
      try {
        switch (data.name) {
          case 'defect_box':
            if (Array.isArray(this.model.defect_box)) {
              this.$set(this.model.defect_box, data.index, data.selects);
            }
            break;

          case 'defect_id':
            if (Array.isArray(this.model.defect_id)) {
              this.$set(this.model.defect_id, data.index, data.selects);
              const defectSelected = this.model.defect_id[data.index]
                ? this.getNameSelected(
                    this.model.defect_id[data.index],
                    this.defects
                  )
                : null;

              this.$set(
                this.model.defect_name_selected,
                data.index,
                defectSelected
              );
            }
            break;

          default:
            console.warn(
              `El nombre de campo ${data.name} no está siendo manejado en el objeto.`
            );
            break;
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        // Solo validar si hay defectos registrados
        if (this.model.defect_quantity > 0) {
          for (let i = 0; i < this.model.defect_quantity; i++) {
            if (!isset(this.model.defect_box[i])) {
              return this.validationInputsRequired(`defect_box`);
            } else if (!isset(this.model.defect_id[i])) {
              return this.validationInputsRequired(`defect_id`);
            } else if (this.isDuplicateBoxDefect(i)) {
              SweetAlert.warning(
                i18n.t('boxinspection.box_defect_repeated', {
                  caja: this.model.defect_box[i],
                  defecto: this.getDefectName(this.model.defect_id[i]),
                })
              );

              return false;
            }
          }

          // Validar que la suma de clusters de defectos por caja no supere el total parametrizado
          if (!this.validateClustersPerBox()) {
            return false;
          }
        }
        this.$emit('on-validated', {
          ...this.model,
          defects: this.defects, // Incluir la lista de defectos con la propiedad discountable
        });

        return res;
      });
    },

    validateClustersPerBox() {
      // Crear un objeto para sumar los clusters por caja
      const clustersPerBox = {};
      
      // Inicializar contadores para cada caja
      for (let i = 1; i <= this.box_quantity; i++) {
        clustersPerBox[i] = 0;
      }

      // Sumar los clusters de defectos por caja
      for (let i = 0; i < this.model.defect_quantity; i++) {
        if (
          isset(this.model.defect_box[i]) &&
          isset(this.model.defect_cluster_quantity[i])
        ) {
          const boxNumber = this.model.defect_box[i];
          const clusterQuantity = parseInt(this.model.defect_cluster_quantity[i]) || 0;
          clustersPerBox[boxNumber] += clusterQuantity;
        }
      }

      // Validar que no se supere el total parametrizado para cada caja
      for (let i = 1; i <= this.box_quantity; i++) {
        const totalClustersDefects = clustersPerBox[i];
        const maxClustersAllowed = this.box_total_clusters[i - 1] || 0;

        if (totalClustersDefects > maxClustersAllowed) {
          SweetAlert.warning(
            i18n.t('boxinspection.clusters_exceeded_validation', {
              caja: i,
              totalDefects: totalClustersDefects,
              maxAllowed: maxClustersAllowed,
            })
          );

          return false;
        }
      }

      return true;
    },

    isDuplicateBoxDefect(currentIndex) {
      const currentBox = this.model.defect_box[currentIndex];
      const currentDefect = this.model.defect_id[currentIndex];

      for (let i = 0; i < currentIndex; i++) {
        if (
          this.model.defect_box[i] === currentBox &&
          this.model.defect_id[i] === currentDefect
        ) {
          return true;
        }
      }

      return false;
    },

    getDefectName(defectId) {
      const defect = this.defects.find((d) => d.id === defectId);
      return defect ? defect.name : defectId;
    },
  },
  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('quality/defectgroups')
        .then((response) => {
          const groups = response.data.data;

          this.defects = groups.flatMap((category) =>
            category.subgroups.map((defect) => ({
              id: defect.id,
              name: `${i18n.t('common_words.category')}: ${capitalizeString(
                category.name
              )} - ${i18n.t('production.defect')}: ${capitalizeString(
                defect.name
              )}`,
              discountable: defect.discountable || false, // Incluir propiedad discountable
            }))
          );

          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            const editForm = JSON.parse(sessionStorage.getItem('editForm'));
            const { box_inspection_boxes } = editForm;

            // Contar defectos totales de todas las cajas
            let totalDefects = 0;
            const defectBoxes = [];
            const defectIds = [];
            const defectClusterQuantities = [];
            const defectNameSelected = [];

            if (box_inspection_boxes && box_inspection_boxes.length > 0) {
              box_inspection_boxes.forEach((box, boxIndex) => {
                if (
                  box.box_inspection_defects &&
                  box.box_inspection_defects.length > 0
                ) {
                  box.box_inspection_defects.forEach((defect) => {
                    // Usar el box_number real de la base de datos, no el índice
                    defectBoxes.push(parseInt(box.box_number));
                    defectIds.push(defect.quality_defect_subgroup_id);
                    defectClusterQuantities.push(defect.number_clusters || 0);
                    defectNameSelected.push(
                      this.getNameSelected(
                        defect.quality_defect_subgroup_id,
                        this.defects
                      )
                    );
                    totalDefects++;
                  });
                }
              });
            }

            // Configurar el modelo con la cantidad real de defectos (puede ser 0)
            this.model = {
              ...this.model,
              defect_quantity: totalDefects,
              defect_box: defectBoxes,
              defect_id: defectIds,
              defect_cluster_quantity: defectClusterQuantities,
              defect_name_selected: defectNameSelected,
            };
          }
        })
        .catch((error) => this.showMessageErrors(error));

      this.showHideLoading();
    } else this.showHideLoading();
  },
};
</script>
